export default {

  ko_purchase: {
    100: '입금대기',
    101: '결제완료',
    200: '상품준비중',
    300: '배송대기',
    301: '배송중',
    302: '배송완료',
    303: '배송지연',
    400: '구매확정',
    500: '교환요청',
    501: '교환결제완료',
    502: '교환상품준비중',
    503: '교환보류',
    504: '교환배송중',
    505: '교환배송완료',
    506: '교환배송지연',
    507: '교환구매확정',
    900: '결제취소',
    901: '결제취소완료',
    902: '교환취소',
    903: '반품요청',
    904: '반품완료',
    905: '환불요청',
    906: '환불완료',
  },

}
